import { customAxios } from '../../common/customAxios';

interface IPostSignUpParams {
  reqBody: {
    signUpToken: string;
    advertisementTermsAgreement: boolean;
    marketingTermsAgreement: boolean;
    latitude: string;
    longitude: string;
    residence: {
      regionDepth1: string;
      regionDepth2: string;
      regionDepth3: string;
    };
    job: string;
    extraInfoOfJob?: {
      infoType: string;
      infoValue: string;
    }[];
    joinReason: string;
    joinReasonEtc: string;
    ownTractor: string | null;
    purchaseTractorYn: string | null;
  };
}

interface IPostSignUpResponseData {
  accessToken: string;
}

export const postSignUp = ({ reqBody }: IPostSignUpParams): Promise<IPostSignUpResponseData> => {
  return customAxios.post('/auth/sign-up', reqBody);
};
